import { PDFStamper } from "@/components/PDFStamper";

const Index = () => {
  return <PDFStamper />;
};

export default Index;
